import {
  getContentFeed,
  getFeaturedContentFeed,
  searchContent,
} from '@/api/feed';

export default {
  namespaced: true,
  state: {
    content: [],
    contentLoading: false,
    featuredContent: [],
    featuredContentLoading: false,
    moreContentLoading: false,
    hasMoreContent: true,
    page: 1,
  },
  mutations: {
    setContent(state, content) {
      state.content = content;
    },
    setContentLoading(state, isLoading) {
      state.contentLoading = isLoading;
    },
    setMoreContentLoading(state, isLoading) {
      state.moreContentLoading = isLoading;
    },
    appendContent(state, content) {
      if (content.length === 0) state.hasMoreContent = false;
      else {
        state.content = [...state.content, ...content];
        state.page += 1;
      }
    },
    resetPagination(state) {
      state.hasMoreContent = true;
      state.page = 1;
    },
    setFeaturedContent(state, content) {
      state.featuredContent = content;
    },
    setFeaturedContentLoading(state, isLoading) {
      state.featuredContentLoading = isLoading;
    },
  },
  actions: {
    async loadContent({ commit }) {
      try {
        commit('setContentLoading', true);
        const { data } = await getContentFeed();
        commit('setContent', data);
        commit('setContentLoading', false);
      } catch (error) {
        commit('setContentLoading', false);
      }
    },
    async loadMoreContent({ commit, state }) {
      try {
        commit('setMoreContentLoading', true);
        const { data } = await getContentFeed(state.page);
        commit('appendContent', data);
      } finally {
        commit('setMoreContentLoading', false);
      }
    },
    async loadFeaturedContent({ commit }) {
      try {
        commit('setFeaturedContentLoading', true);
        const { data } = await getFeaturedContentFeed();
        commit('setFeaturedContent', data);
        commit('setFeaturedContentLoading', false);
      } catch (error) {
        commit('setFeaturedContentLoading', false);
      }
    },
    async searchContent({ commit }, query) {
      try {
        commit('setContentLoading', true);
        const { data } = await searchContent(query);
        commit('setContent', data);
        commit('setContentLoading', false);
      } catch (error) {
        console.error(error);
        commit('setContentLoading', false);
      }
    },
  },
};
